import animations from 'Assets/js/modules/animations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';

export default function heroFullscreenJS(options = {}) {
  try {
    const { block } = options;
    jsUtils.loadCss(block.dataset.assetkey, options).then(() => {
      if (block.dataset.colour_filter !== 'none') {
        // Set CSS variable
        document.body.style.setProperty(
          '--hero-fullscreen-opacity',
          +block.dataset.colour_filter_opacity / 100
        );
      }
      animations.fadeIn(block);

      const videoBlock = block.querySelector('.hero-fullscreen__video video');

      if (videoBlock === null || videoBlock === undefined) {
        return;
      }

      // Just video code here below
      const soundButton = block.querySelector(
        '.hero-fullscreen__sounds-control'
      );

      if (typeof(soundButton) != 'undefined' && soundButton != null) {
        const soundButtonOn = soundButton.querySelector(
          '.hero-fullscreen__sounds-on'
        );
        const soundButtonOff = soundButton.querySelector(
          '.hero-fullscreen__sounds-off'
        );
        const soundLabelOn = soundButton.querySelector(
          '.hero-fullscreen__sound-label-on'
        );
        const soundLabelOff = soundButton.querySelector(
          '.hero-fullscreen__sound-label-off'
        );
        soundButton.addEventListener('click', () => {
          if (videoBlock.muted) {
            soundButtonOn.style.display = 'block';
            soundButtonOff.style.display = 'none';
            soundLabelOn.style.display = 'none';
            soundLabelOff.style.display = 'block';
          } else {
            soundButtonOn.style.display = 'none';
            soundButtonOff.style.display = 'block';
            soundLabelOn.style.display = 'block';
            soundLabelOff.style.display = 'none';
          }
          videoBlock.muted = !videoBlock.muted;
        });
      }

      const playButton = block.querySelector('.hero-fullscreen__play-control');
      const playButtonOn = playButton.querySelector(
        '.hero-fullscreen__play-on'
      );
      const playButtonOff = playButton.querySelector(
        '.hero-fullscreen__play-off'
      );
      const playLabelOn = playButton.querySelector(
        '.hero-fullscreen__play-label-on'
      );
      const playLabelOff = playButton.querySelector(
        '.hero-fullscreen__play-label-off'
      );
      playButton.addEventListener('click', () => {
        if (videoBlock.paused) {
          playButtonOn.style.display = 'none';
          playButtonOff.style.display = 'block';
          playLabelOn.style.display = 'none';
          playLabelOff.style.display = 'block';
          videoBlock.play();
        } else {
          playButtonOn.style.display = 'block';
          playButtonOff.style.display = 'none';
          playLabelOn.style.display = 'block';
          playLabelOff.style.display = 'none';
          videoBlock.pause();
        }
      });
    });
  } catch (error) {
    console.error(error);
  }
}
